import { configureStore } from '@reduxjs/toolkit';

import { authReducer } from '../features/auth/store/auth-slice.js';
import { storeScopeReducer } from '../features/stores/store/store-scope-slice.js';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    storeScope: storeScopeReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
